import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.js";
import * as Sentry from "@sentry/react";
import "./_css/index.css";
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router-dom";

Sentry.init({
  dsn: "https://6c71b4c4094302994fe2dad5ac9862d8@o349349.ingest.us.sentry.io/4509695088525312",
  integrations: [
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect: React.useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 1.0,
  tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  environment: import.meta.env.MODE.toLowerCase(),
  enabled: import.meta.env.MODE !== "development",
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />,
  </React.StrictMode>,
);
